<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Input/NewDInputEditor'
export default {
  name: 'NewDEmailEditor',
  extends: compoment
}
</script>
